module.exports = __webpack_public_path__ + "static/bitmap-beatrice-dagostino-dd6db07c3f68d13e55b351816aca18bb.png";